// src/store.ts
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { registerStoreForLogout } from '../utils/authActions';
import tiersReducer from './TiersSlice';
import tiersPlafondReducer from './TiersPlafondSlice';
import GroupeBienReducer from './GroupeBienSlice';  
import BienReducer from './BienSlice'
import ContratLocationReducer from './contratLocationSlice';  
import ArticleReducer from './ArticleSlice';  
import DocumentVenteReducer from './documentVenteSlice';  
import LigneDocumentVenteReducer from './LigneDocumentVenteSlice';  
import GeneriqueDataReducer from './GeneriqueDataSlice';
import ReglementReducer from './ReglementSlice';
import CompteReducer from './compteSlice';
import SysTypeDocumentReducer from './SysTypeDocumentSlice' ;
import SysGeneriqueDataTypeReducer from './SysGeneriqueDataTypeSlice';
import TacheReducer from './TacheSlice'; // Import your Tache slice reducer
import UserReducer from './UserSlice'; // Import your User slice reducer
import FamilleReducer from './FamilleSlice';
import StockReducer from './StockSlice';
import DepartementReducer from './DepartementSlice';
import AppReducer from './AppSlice';
import AuthReducer from './AuthSlice';
import RoleReducer from './RoleSlice';
import PermissionReducer from './PermissionSlice';
import ScopeReducer from './ScopeSlice';
import ReportTemplateReducer from './ReportTemplateSlice';
import ReportJobReducer from './ReportJobSlice';
import WorkflowEtapeReducer from './WorkflowEtapeSlice';
import WorkflowStatutReducer from './WorkflowStatutSlice';
import DashboardReducer from './DashboardSlice';
import PosReducer from './PosSlice';
import OptionReducer from './OptionSlice';
import NomenclatureReducer from './NomenclatureSlice';
import NotificationReducer from './NotificationSlice';
import StatistiqueReducer from './StatistiqueSlice';
import ImmobilisationReducer from './ImmobilisationSlice';
import AiApiTokenReducer from './AiApiTokenSlice';
import AssistantReducer from './AssistantSlice';
import FamilleDefautReducer from './FamilleDefautSlice';

const appReducer = combineReducers({
  TiersSlice: tiersReducer,
  TiersPlafondSlice: tiersPlafondReducer,
  GropueBienSlice: GroupeBienReducer,
  BienSlice: BienReducer,
  ContratLocationSlice: ContratLocationReducer,
  ArticleSlice: ArticleReducer,
  DocumentVenteSlice: DocumentVenteReducer,
  LigneDocumentVenteSlice: LigneDocumentVenteReducer,
  GeneriqueDataSlice: GeneriqueDataReducer,
  ReglementSlice: ReglementReducer,
  CompteSlice: CompteReducer,
  SysTypeDocumentSlice: SysTypeDocumentReducer,
  SysGeneriqueDataTypeSlice: SysGeneriqueDataTypeReducer,
  TacheSlice: TacheReducer,
  UserSlice: UserReducer,
  FamilleSlice: FamilleReducer,
  FamilleDefautSlice: FamilleDefautReducer,
  StockSlice: StockReducer,
  DepartementSlice: DepartementReducer,
  AppSlice: AppReducer,
  AuthSlice: AuthReducer,
  RoleSlice: RoleReducer,
  PermissionSlice: PermissionReducer,
  ScopeSlice: ScopeReducer,
  ReportTemplateSlice: ReportTemplateReducer,
  ReportJobSlice: ReportJobReducer,
  WorkflowEtapeSlice: WorkflowEtapeReducer,
  WorkflowStatutSlice: WorkflowStatutReducer,
  DashboardSlice: DashboardReducer,
  PosSlice: PosReducer,
  OptionSlice: OptionReducer,
  NomenclatureSlice: NomenclatureReducer,
  NotificationSlice: NotificationReducer,
  StatistiqueSlice: StatistiqueReducer,
  ImmobilisationSlice: ImmobilisationReducer,
  AiApiTokenSlice: AiApiTokenReducer,
  AssistantSlice: AssistantReducer,
});

// Réinitialise tout le store au logout — évite les fuites de données inter-tenant
const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: any) => {
  if (action.type === 'auth/logout') {
    state = undefined;
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

// Enregistrer le store pour forceLogout (cycle import cassé via inversion)
registerStoreForLogout(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Custom hooks for dispatching and selecting
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
